const studentUser3 = {
  id: '7c61ec30-3243-11e8-89ad-f12e43ca89ff',
  email: 'joe@example.com',
  username: 'joe@example.com',
  firstName: 'Joe',
  lastName: 'Thestudent',
  fullName: 'Joe Thestudent',
  lastModified: 1521738144176,
  created: 1521738144176,
  role: 'Student',
  schoolDistrict: 'c85d02d0-2ff2-11e8-bb3c-cb20d31ae9b7',
  school: 'f6365530-310a-11e8-ae0c-5fd82a1b2893',
  classes: {
    '25c22030-4192-11e8-95ba-7d1e83afad64': true,
    '2cadabd0-4192-11e8-95ba-7d1e83afad64': true,
  },
  state: 'MS',
}

export default studentUser3


// WEBPACK FOOTER //
// ./src/helpers/users/testing/studentUser3.js